export default "__VITE_ASSET__ec58319d__"